import { Tooltip } from "antd";

const TableTitle = ({ title }: { title: string }) => (
  <Tooltip title={title} placement="left" color={"var(--tertiary-color)"}>
    <span style={{ whiteSpace: "nowrap", overflow: "visible" }}>{title}</span>
  </Tooltip>
);

export default TableTitle;
